let lastKnownScrollPosition = 0;
let ticking = false;
let pageHero = document.querySelector(".collection-hero") || document.querySelector(".page-hero");

window.onload = function() {

  document.addEventListener('scroll', (e) => {
    lastKnownScrollPosition = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(() => {
        checkHeroFade(lastKnownScrollPosition);
        ticking = false;
      });
      ticking = true;
    }
  });

};

function checkHeroFade(scrollPos) {
  if(pageHero != null) {
    if(scrollPos > (window.pageYOffset + pageHero.getBoundingClientRect().top + (pageHero.offsetHeight / 4))) {
      pageHero.classList.add("hero-fade");
    } else {
      pageHero.classList.remove("hero-fade");
    }
  }
}
